import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export async function setClientDocumentStatus(currentUid) {
  console.log("setClientDocumentStatus currentUid", currentUid)
  await firebaseRef
    .ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
    .orderByChild('createrID')
    .equalTo(currentUid)
    .on('value', (snapshot) => {
      var salesAgentParentObj = snapshot.val();

      console.log("salesAgentParentObj", salesAgentParentObj)

      if (salesAgentParentObj) {
        var salesAgentKeys = Object.keys(salesAgentParentObj);

        var salesAgentObj = salesAgentParentObj[salesAgentKeys[0]];
  
        var myClientsObj = salesAgentObj?.myClients;
  
        var myClientsObjKeys = myClientsObj && Object.keys(myClientsObj);
  
        //foreach throught the client list
        myClientsObjKeys?.forEach((clientKey) => {
          var client = myClientsObj[clientKey];
  
          //check if there is document information
          if (client['documentInformation']) {
            if (client['documentInformation']['signatureRequests']) {
              console.log('clientKey', clientKey);
  
              //begin check the signature status
            }
          }
        });
      }
    });
}
